// @flow

import _ from 'lodash';

import { root as rootLogContext } from 'log-context';
import { LkSplunkLogger } from 'splunk-logger';

import type { Error } from 'error';

import TraceKitContextSubscriber from './subscriber';

export default class SaveSplunkLogMessageForClientSubscriber extends TraceKitContextSubscriber {
	_logContext = rootLogContext.subcontext({
		splunkLogger: new LkSplunkLogger(),
	});

	onError (ctx: Object, error: Error) {
		const { correlationIds, handled } = error;

		if (!correlationIds || !correlationIds.length) {
			return;
		}

		if (!handled || handled.type !== 'notification') {
			return;
		}

		_.each(error.correlationIds, correlationId => {
			this._logContext.followup({
				CorrelationId: correlationId,
				ext: {
					Error: {
						MessageForClient: handled.message,
					},
				},
			});
		});
	}
}
